import { css } from 'styled-components';

export default function smallBorderStyle() {
  return css`
    width: 3rem;
    height: .125rem;
    background-color: rgba(170,170,170,.5);
`;
}
